import { action, ActionType } from 'typesafe-actions';
import { Stage, CodeSource } from './types';

export const CHANGE_STAGE = 'SIGNIN_FORM/CHANGE_STAGE';

export const ACTIVATE = 'SIGNIN_FORM/ACTIVATE';
export const DEACTIVATE = 'SIGNIN_FORM/DEACTIVATE';

export const actions = {
  changeStage: (stage: Stage, codeSource: CodeSource, sessionId: string) =>
    action(CHANGE_STAGE, { stage, codeSource, sessionId }),
};

export type Action = ActionType<typeof actions>;

export const lifecycle = {
  activate: () => action(ACTIVATE),
  deactivate: () => action(DEACTIVATE),
};

export type Lifecycle = ActionType<typeof lifecycle>;
